import { bt, seatLabel } from '@/i18n/bookingI18n';
import { BUS_TYPES, fareVAT, money } from '@/data/transportPricing';
import { validateSchedule, validateContact } from '@/components/booking/validateCommon';

export function busPriceFor({ opt, v }) {
  return opt ? opt.prices[BUS_TYPES.findIndex((x) => x.id === v.id)] : null;
}

export function computeBusEstimate({ opt, busType, busIndex, isAirport, returnTrip, lang }) {
  if (!opt || !busType) return null;
  let net = opt.prices[busIndex];
  if (isAirport && returnTrip) net *= 2;
  const { vat, total } = fareVAT(net);
  const retWord = isAirport && returnTrip ? ` (${bt(lang, 'returnWord')})` : '';
  const retSuffix = isAirport && returnTrip ? bt(lang, 'returnSuffix') : '';
  return {
    summary: `${busType.name} (${seatLabel(lang, `${busType.seats}-seat`)}) · ${opt.name}${retWord}`,
    lines: [
      { label: `${busType.name} · ${opt.name}${retSuffix}`, value: money(net) },
      { label: bt(lang, 'vat5'), value: money(vat) },
    ],
    total,
  };
}

export function validateBus({ destIdx, busId, date, time, form, lang }) {
  const e = { ...validateSchedule({ date, time, lang }), ...validateContact({ form, lang }) };
  if (destIdx === '') e.dest = bt(lang, 'errDest');
  if (!busId) e.bus = bt(lang, 'errBus');
  return e;
}
